module.exports = __webpack_public_path__ + "static/media/exchange.d2064303.png";